import { createGlobalStyle } from 'styled-components';

const GeneratedThumbnaisStyles = createGlobalStyle`
  .generated-images-holder {
    position: absolute;
    bottom: 100%;
    right: 100%;
  }
  .background {
    position: absolute;
    left: 0;
    top: 0;
  }
  .image-holder {
    width: 100%;
    display: flex;
    position: relative;
    height: 1080px;
  }
  .break {
    position: absolute;
    width: 20px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 10px);
    z-index: 1;
  }
  .foreground {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .half-image {
    width: 1120px;
    height: 1080px;
    object-fit: cover;
    position: relative;
  }
`;

export default GeneratedThumbnaisStyles;
